export function getUrl(signinUrl, path) {
    return (from = typeof window !== 'undefined' ? window.location.href : '') => `${signinUrl}${path}?from=${encodeURIComponent(from)}`;
}
